import Vue from 'vue';
import Toast from './toast.vue';
/**
 * 显示 Toast 提示
 * @param {string} [message=''] - 提示文本
 * @param {number} [delay=2000] - 自动关闭延迟（毫秒）
 * @param {string|HTMLElement} [target='body'] - 插入的目标节点（选择器字符串或DOM元素）
 */
export default function showToast(message = '', delay = 2000, target = '.app') {
  // 移除之前可能存在的toast元素（避免重复）
  const prevToast = document.getElementById('my-toast');
  if (prevToast) {
    prevToast.remove();
  }
  // 创建组件实例
  const toastInstance = new Vue({
    render: h => h(Toast, {
      props: {
        message
      }
    })
  }).$mount();
  // 创建容器
  const container = document.createElement('div');
  container.id = 'my-toast';
  container.appendChild(toastInstance.$el);
  // 获取目标节点（支持选择器字符串或DOM元素）
  let targetNode;
  if (typeof target === 'string') {
    // 如果是字符串，视为选择器
    targetNode = document.querySelector(target);
  } else if (target instanceof HTMLElement) {
    // 如果是DOM元素，直接使用
    targetNode = target;
  }
  // 兜底：如果目标节点不存在，默认插入到body
  if (!targetNode) {
    targetNode = document.body;
  }
  // 将容器插入到目标节点（作为目标节点的子元素）
  targetNode.appendChild(container);
  // 定时移除toast
  setTimeout(() => {
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
    toastInstance.$destroy();
  }, delay);
}